import styled from 'styled-components'
import { Icon } from '@navent-jobs/ui-kit/components/icon'

export const InformationList = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px;
  margin: 0px;
  line-height: 16px;

  & > div > li:first-child {
    margin-top: 16px;
  }

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    flex-direction: row;
  }
`

export const AdditionalInfoWrapper = styled('div')`
  margin-top: 16px;

  @media (max-width: ${({ theme }) => theme.screen.mdMax}) {
    margin-top: 12px;
  }
`

export const CompanyInfo = styled('div')`
  display: flex;
`

export const IconInfo = styled(Icon)`
  margin-right: 8px;
`

export const CustomIcon = styled(Icon)`
  margin-right: 8px;
`
